"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TextInputRenderer_1 = __importDefault(require("./components/TextInputRenderer"));
const PageRenderer_1 = __importDefault(require("./components/PageRenderer"));
const ButtonRenderer_1 = __importDefault(require("./components/ButtonRenderer"));
const ContainerRenderer_1 = __importDefault(require("./components/ContainerRenderer"));
const ImageRenderer_1 = __importDefault(require("./components/ImageRenderer"));
const TextAreaRenderer_1 = __importDefault(require("./components/TextAreaRenderer"));
const SwitchRenderer_1 = __importDefault(require("./components/SwitchRenderer"));
const CameraViewRenderer_1 = __importDefault(require("./components/CameraViewRenderer"));
const MapRenderer_1 = __importDefault(require("./components/MapRenderer"));
const WebViewRenderer_1 = __importDefault(require("./components/WebViewRenderer"));
const IconRenderer_1 = __importDefault(require("./components/IconRenderer"));
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const PickerRenderer_1 = __importDefault(require("./components/PickerRenderer"));
const FlatListRenderer_1 = __importDefault(require("./components/FlatListRenderer"));
const SectionListRenderer_1 = __importDefault(require("./components/SectionListRenderer"));
const SideMenuRenderer_1 = __importDefault(require("./components/SideMenuRenderer"));
const VideoViewRender_1 = __importDefault(require("./components/VideoViewRender"));
const SwiperRender_1 = __importDefault(require("./components/SwiperRender"));
const CalendarRenderer_1 = __importDefault(require("./components/CalendarRenderer"));
const GraphicRender_1 = __importDefault(require("./components/GraphicRender"));
const RadioButtonRender_1 = __importDefault(require("./components/RadioButtonRender"));
const SliderRenderer_1 = __importDefault(require("./components/SliderRenderer"));
const DatePickerRender_1 = __importDefault(require("./components/DatePickerRender"));
const BottomMenuSheetRenderer_1 = __importDefault(require("./components/BottomMenuSheetRenderer"));
const CheckboxRenderer_1 = __importDefault(require("./components/CheckboxRenderer"));
const VideoRenderer_1 = __importDefault(require("./components/VideoRenderer"));
const BannerAdRenderer_1 = __importDefault(require("./components/BannerAdRenderer"));
const JitsiMeetRenderer_1 = __importDefault(require("./components/JitsiMeetRenderer"));
const StyleFormaterContext_1 = __importDefault(require("../components/WithStyleFormaterContext/StyleFormaterContext"));
const ControlRenderers = {
    page: PageRenderer_1.default,
    View: ContainerRenderer_1.default,
    parallax: ContainerRenderer_1.default,
    button: ButtonRenderer_1.default,
    ionitem: TextInputRenderer_1.default,
    image: ImageRenderer_1.default,
    text: TextAreaRenderer_1.default,
    switch: SwitchRenderer_1.default,
    camera: CameraViewRenderer_1.default,
    map: MapRenderer_1.default,
    webView: WebViewRenderer_1.default,
    icon: IconRenderer_1.default,
    Picker: PickerRenderer_1.default,
    fileInput: ButtonRenderer_1.default,
    flatList: FlatListRenderer_1.default,
    sectionList: SectionListRenderer_1.default,
    ScrollView: ContainerRenderer_1.default,
    sideMenu: SideMenuRenderer_1.default,
    bottomMenuSheet: BottomMenuSheetRenderer_1.default,
    videoView: VideoViewRender_1.default,
    Swiper: SwiperRender_1.default,
    calendar: CalendarRenderer_1.default,
    graphicView: GraphicRender_1.default,
    radio: RadioButtonRender_1.default,
    slider: SliderRenderer_1.default,
    datePicker: DatePickerRender_1.default,
    topNavBar: ContainerRenderer_1.default,
    checkbox: CheckboxRenderer_1.default,
    video: VideoRenderer_1.default,
    bannerAd: BannerAdRenderer_1.default,
    jitsiMeet: JitsiMeetRenderer_1.default,
};
const ControlRenderer = ({ control, parent, isContainerViewScroll, }) => {
    const { wrappers: { renderControlWrapper }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const styleFormater = (0, react_1.useContext)(StyleFormaterContext_1.default);
    if (!control) {
        return null;
    }
    if (control.isHidden) {
        return null;
    }
    const ControlRendererC = ControlRenderers[control.tag];
    if (!ControlRendererC) {
        return null;
    }
    const controlStyle = styleFormater(control, !!renderControlWrapper && control.tag !== 'topNavBar');
    const renderedControl = (react_1.default.createElement(ControlRendererC, { parent: parent, control: control, style: controlStyle }));
    if (renderControlWrapper) {
        return renderControlWrapper({
            isContainerViewScroll,
            control,
            parent,
            style: controlStyle,
            children: renderedControl,
        });
    }
    return renderedControl;
};
exports.default = ControlRenderer;
